import Login from './Login';
import Main from './Main';

export default { Login, Main };
